/**
 * Javascript for product pages
 */
(function (window, document, $, undefined) {
	"use strict";

	$(document).ready(function () {
		// When a Share Class is selected via the hero drop down automatically submit the form
		$("#share-class-select").on("change", function () {
			this.form.submit();
		});

		// Quarter selector for Frequency Distribution
		$("#frequency-distribution-quarter-select").change(function () {
			var select = $("#frequency-distribution-quarter-select").val();
			// All all quarters
			$(".frequency-distribution-table").hide();
			// Show the selected quarter
			$("#" + select).show();
		});

		//Toggles class to rotate arrow up or down on click
		$(
			".jh_product-template-default #sidebar .jh-collapse-card .accordion-item a.card-link"
		).click(function () {
			$(this).parent().toggleClass("rotate");
		});

		// Full Holdings Download Link.
		$("#full-holdings-download").click(function (event) {
			event.preventDefault();
			// The link we want to download
			var download_link = encodeURI($(this).attr("href"));
			// Show the spinner because sometimes the calls can be a little on the slow side.
			$(this).children(".full-holdings-spinner").show();
			// Make the simple Ajax call.
			$.get(download_link).done(function (data) {
				// Get just the Full Holdings table.
				var table_data = $("table#full_holdings", data).get(0);
				// Generate the file and download.
				full_holdings_download(table_data);
				$(".full-holdings-spinner").hide();
			});
			return false;
		});

		// Function to parse the Full Holdings table and download it as a CSV.
		function full_holdings_download(table_data) {
			let table = table_data;
			let tbody = table.getElementsByTagName("tbody")[0];
			let thead = table.getElementsByTagName("thead")[0];
			// Extract headers
			let headers = Array.from(thead.getElementsByTagName("th")).map(
				(th, index) => {
					if (index === 0) {
						return "Full Portfolio Holdings"; // Set the first header explicitly
					} else {
						let span = th.querySelector("span.fund-percentage");
						return span ? span.innerText.trim() : "";
					}
				}
			);
			let product = document.querySelector("h1.entry-title");
			let productName;
			if (!product) {
				product = document.getElementsByClassName(
					"product-name notranslate"
				);
				productName = product[0].innerText.split("\n")[1].trim();
			} else {
				productName = product.innerText;
			}
			let downloadName =
				"Full Holdings " +
				productName +
				" - Janus Henderson Investors.csv";
			let csv = [];
			csv.push(headers.join(",")); // Add headers to CSV

			// Extract data rows
			let rows = Array.from(tbody.rows);

			for (let row of rows) {
				let cols = Array.from(row.cells);
				let csvRow = cols.map((col) => {
					let text = col.innerText.trim().replace(/"/g, '""'); // Escape quotes.

					// Use quotes if there are commas, quotes, newlines, or special characters.
					if (
						text.includes(",") ||
						text.includes('"') ||
						text.includes("\n") ||
						text.includes("#")
					) {
						text = `"${text}"`;
					}

					return text;
				});

				csv.push(csvRow.join(","));
			}

			// Join all rows to form a complete CSV string.
			let csvString = csv.join("\n");

			// Create a Blob object with the CSV data.
			let blob = new Blob([csvString], {
				type: "text/csv;charset=utf-8;",
			});

			// Create a link element
			let link = document.createElement("a");
			let url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", downloadName);

			// Append the link to the body and trigger the download.
			document.body.appendChild(link);
			link.click(); // Trigger download

			// Cleanup: remove the link and revoke the object URL.
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		}

		// If the URL has a download parameter find the table and download it.
		var urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has("download") === true) {
			let content = document.getElementById("full_holdings");
			full_holdings_download(content);
		}

		// Negative Numbers Max in Allocation Graphs
		$(".fund-chart-bar-negative").each(function () {
			if (
				$(this).children(".fund-bar").width() >=
				$(this).parent().prev().width()
			) {
				var negative_max_width = $(this).parent().prev().width();
				$(this).css("max-width", Math.floor(negative_max_width) + "px");
				if ($(this).children(".fund-bar").width() > "50") {
					$(this).children(".fund-bar").addClass("add-graph-break");
				}
			}
		});
		$(".index-chart-bar-negative").each(function () {
			if (
				$(this).children(".index-bar").width() >=
				$(this).parent().prev().width()
			) {
				var negative_max_width = $(this).parent().prev().width();
				$(this).css("max-width", Math.floor(negative_max_width) + "px");
				if ($(this).children(".index-bar").width() > "50") {
					$(this).children(".index-bar").addClass("add-graph-break");
				}
			}
		});
	});
})(window, document, jQuery);

/* External Link */
// Open external links in a popup modal notice

/**
 * Javascript for product pages
 */
(function (window, document, $, undefined) {
	$(function () {
		$("a.ext_link, li.ext_link").click(function (e) {
			// prevent link from opening
			e.preventDefault();
			// open a modal
			$(this).attr("data-toggle", "modal");
			$(this).attr("data-target", "#speedbump");
			var type = $(this).attr("data-fund-type");
			switch (type) {
				case "form-nfp": // For Form-NFP modal content
					$("#speedbump .modal-body .default-content").hide();
					$("#speedbump .modal-body .mm-content").show();
					break;
				default: // For default modal content
					$("#speedbump .modal-body .default-content").show();
					$("#speedbump .modal-body .mm-content").hide();
			}
			//go to link on modal close
			var url = "";
			if ($(this).attr("href") && $(this).attr("href").length) {
				url = $(this).attr("href");
			}
			if (
				$(this).find("a").attr("href") &&
				$(this).find("a").attr("href").length
			) {
				url = $(this).find("a").attr("href");
			}

			// set window.open in the button, this is to avoid canceled click events from propagating
			url = "window.open('" + url + "');";
			$(".btn-modal.btn-continue").attr("onclick", url);

			$(".btn-modal.btn-continue").click(function () {
				$(".btn-modal.btn-continue").off();
			});
			$(".btn-modal.btn-close").click(function () {
				$("#speedbump").modal("hide");
				$(".btn-modal.btn-close").off();
			});
		});
	});
})(window, document, jQuery);

(function ($) {
	//show bottom border only on collapse for .card in products page
	$(
		".product-wrapper #sidebar .jh-collapse-card .accordion-item a.card-link"
	).on("click", function () {
		if ($(this).find(".show").length) {
			$(this).css({
				"border-bottom": "1px solid #b9c1c7",
				"border-radius": "0px",
			});
		} else {
			$(this).css({
				"border-bottom": "none",
			});
		}
	});

	//fadeIn/fadeOut back2top button when sticky navbar gets triggered
	$(window).scroll(function () {
		var height = $(window).scrollTop();
		if (height > 625) {
			$("#back2Top").fadeIn();
		} else {
			$("#back2Top").fadeOut();
		}
	});

	//auto trigger - Scroll to top on products page
	$("#back2Top").click(function (event) {
		event.preventDefault();
		$.scrollTo(".top-nav-wrap", 1500, { offset: -150 });
		return false;
	});

	// Scroll to the "Specific risks" disclosures tab on click
	$(".fund-risks-scroll").click(function (event) {
		$.scrollTo(".product_disclosure_container", 750, { offset: -75 });
	});
})(jQuery);
